<template>
  <v-autocomplete
    :disabled="disabled"
    :items="optionList"
    :ruleList="ruleList"
    :rules="ruleList"
    clearable
    item-text="label"
    item-value="id"
    outlined
    v-model="value"
  ></v-autocomplete>
</template>

<script>
import formElementMixin from "./formElementMixin";

export default {
  computed: {
    optionList() {
      return this.componentConfig.optionList;
    },
  },
  created() {
    const { optionList } = this;

    // If only one option exists, set value to that option
    if (optionList.length === 1) {
      const [{ id }] = optionList;
      this.value = id;
    }
  },
  mixins: [formElementMixin],
  props: {
    componentConfig: {
      required: true,
      type: Object,
      validator: function (componentConfig) {
        // Must have optionList
        if (!componentConfig.optionList) {
          return false;
        }

        const { optionList } = componentConfig;

        // optionList must have at least one item
        return !!optionList.length;
      },
    },
  },
};
</script>
